import { Blockquote, Amazon, Vocabulary, SoThisIsChristmasIndex, InternalLink, AffiliateBanner } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Vocabulary,
  SoThisIsChristmasIndex,
  InternalLink,
  AffiliateBanner,
  React
};